module.exports = __webpack_public_path__ + "static/media/dlaczego-warto-spedzac-czas-z-dzieckiem.3d1edc02.png";